import configService from './ConfigService'
import HttpService from './HttpService'

class UserProfileService {
  getUserProfile () {
    var url = configService.apiGatewayHost() + '/api-resource/api/users/current'
    return HttpService.get(url)
  }

  getUserAccounts () {
    var url = configService.apiGatewayHost() + '/gw/user-accounts'
    return HttpService.post(url)
  }

  updateUser (data) {
    var url = configService.apiGatewayHost() + '/api-resource/api/users/update'
    return HttpService.patch(url, data)
  }

  setDefaultAccount (data) {
    var url = configService.apiGatewayHost() + '/api-resource/api/users/current/set-default-account'
    return HttpService.post(url, data)
  }

  addMobileNumber (payload) {
    var url = configService.apiGatewayHost() + '/api-resource/api/users/add-mobile'
    return HttpService.post(url, payload)
  }

  deleteMobileNumber () {
    var url = configService.apiGatewayHost() + '/api-resource/api/users/delete-mobile'
    return HttpService.post(url)
  }

  verifyMobileNumber (payload) {
    var url = configService.apiGatewayHost() + '/api-resource/api/users/verify-mobile'
    return HttpService.post(url, payload)
  }

  resendSmsCode () {
    var url = configService.apiGatewayHost() + '/api-resource/api/users/resend-sms-code'
    return HttpService.post(url)
  }

  updatePostLoginSetting (data) {
    var url = configService.apiGatewayHost() + '/api-resource/api/users/current/login-landing-setting'
    return HttpService.patch(url, data)
  }
}

export default new UserProfileService()
